import { html } from "lit";
import { TemplateResult } from "lit-html";
import { customElement, property } from "lit/decorators.js";
import BaseInput from "./BaseInput";

@customElement("basic-number-input")
class BasicNumberInput extends BaseInput {
	@property({ type: Number }) step = 1;
	@property({ type: String }) placeholder = "-";

	protected renderInput(): TemplateResult {
		return html`
            <input 
                id="${this.id}"
                name="${this.name}" 
                type="number" 
                step="${this.step}" 
                value="${this.value}"
                placeholder="${this.placeholder}"
                ?disabled="${this.disabled}"
            />
        `;
	}
}

export default BasicNumberInput;